import { suppliesSubscriptionIdFormat } from "@redotech/redo-marketplace-id";
import * as z from "zod";

export const orderSuppliesSubscriptionNow = {
  name: "orderSuppliesSubscriptionNow" as const,
  input: z.object({ subscriptionId: suppliesSubscriptionIdFormat.schema }),
  output: z.discriminatedUnion("placed", [
    z.object({
      placed: z.literal(true),
      orderId: z.string(),
      orderName: z.string(),
    }),
    z.object({
      placed: z.literal(false),
      reason: z.enum(["not_eligible", "payment_failed"]),
      message: z.string().optional(),
    }),
  ]),
};
